import { Pipe, PipeTransform } from '@angular/core';
import { AutocompleteOption } from '../components/autocomplete/autocomplete-option';

@Pipe({
  name: 'customerFilter'
})
export class CustomerFilterPipe implements PipeTransform {

  transform(value: AutocompleteOption[], type: string): any {
    return value.filter(v => v.sourceObject.type === type)
  }

}
